export const msaMapOptions = { maxZoom: 9, style: 'mapbox://styles/simunovic-marko/cki60qfuy00d119qlwhojf1j7' };